<template>
  <div class="md:flex -mx-8">
    <div class="md:w-1/2 mx-8">
      <div class="mb-8">
        <h3 class="font-semibold py-3">Organisaties</h3>
        <FieldList :fields="organizationFields" />
      </div>
      <div class="mb-8">
        <h3 class="font-semibold py-3">Personen (particuliern &amp; contactpersonen)</h3>
        <FieldList :fields="personFields" />
      </div>
    </div>
    <div class="hidden md:block w-1/2 mx-8">
      <SettingsTip>
        Bepaal hier welke contactgegevens je bij organisaties en personen wilt opslaan.
        Heb jij unieke velden die hier niet tussen staan, dan kun je deze toevoegen onder
        <router-link :to="{ name: 'settings.customfields' }" class="font-semibold">Eigen velden</router-link>
      </SettingsTip>
    </div>
  </div>
</template>

<script>
import SettingsTip from "@/components/SettingsTip";
import FieldList from "@/components/FieldList";

export default {
  components: {
    SettingsTip,
    FieldList
  },

  computed: {
    organizationFields() {
      return this.$store.state.settings.fields.filter(
        f => f.contact_type === "organization"
      );
    },
    personFields() {
      return this.$store.state.settings.fields.filter(
        f => f.contact_type === "person"
      );
    }
  }
};
</script>
